/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTimeOffRejectRequest = {
    properties: {
        rejectReason: {
    type: 'string',
    isRequired: true,
},
    },
};